import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const RoleListData = ({ role, handleRoleClick, columnWidth }) => {

    if (!role) {
        return (
            <Box className='table_row'>
                <Box sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }} className='machines_listview_table_dataRow'><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.description }} className='machines_listview_table_dataRow'><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box
            className='table_row'
            onClick={() => handleRoleClick(role.id)}
        >
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography className='tableBodyTypography'>{role?.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.description, maxWidth: columnWidth.description }}>
                <Typography className='tableBodyTypography'>{role?.description || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}>
                <Iconify icon={'ri:arrow-right-s-line'} />
            </Box>
        </Box>
    );
};

export default RoleListData;